import { reducer as toastr } from 'react-redux-toastr'
import { routerReducer as routing } from 'react-router-redux'
import { combineReducers } from 'redux'

import auth from './authReducer'

import easymsOrganizations from './easymsOrganizationsReducer'

import bookingCategories from './bookingReducers/bookingCategories'
import bookingCurrentOrganization from './bookingReducers/bookingCurrentOrganization'
import bookingOrganizations from './bookingReducers/bookingOrganizations'
import bookingRates from './bookingReducers/bookingRates'
import bookingSync from './bookingReducers/bookingSync'
import bookingEasyms from './bookingReducers/bookingEasyms'

import dobovoApartments from './dobovoReducers/dobovoApartments'
import dobovoCurrentOrganization from './dobovoReducers/dobovoCurrentOrganization'
import dobovoOrganizations from './dobovoReducers/dobovoOrganizations'
import dobovoSync from './dobovoReducers/dobovoSync'
import dobovoEasyms from './dobovoReducers/dobovoEasyms'

import expediaCategories from './expediaReducers/expediaCategories'
import expediaCurrentOrganization from './expediaReducers/expediaCurrentOrganization'
import expediaOrganizations from './expediaReducers/expediaOrganizations'
import expediaRates from './expediaReducers/expediaRates'
import expediaSync from './expediaReducers/expediaSync'
import expediaEasyms from './expediaReducers/expediaEasyms'

import h24Categories from './h24Reducers/h24Categories'
import h24CurrentOrganization from './h24Reducers/h24CurrentOrganization'
import h24Organizations from './h24Reducers/h24Organizations'
import h24Rates from './h24Reducers/h24Rates'
import h24Sync from './h24Reducers/h24Sync'
import h24Easyms from './h24Reducers/h24Easyms'

import hwCategories from './hostelWorldReducers/hwCategories'
import hwCurrentOrganization from './hostelWorldReducers/hwCurrentOrganization'
import hwOrganizations from './hostelWorldReducers/hwOrganizations'
import hwRates from './hostelWorldReducers/hwRates'
import hwSync from './hostelWorldReducers/hwSync'
import hwEasyms from './hostelWorldReducers/hwEasyms'

import omnitecOrganizations from './omnitecReducers/omnitecOrganizations'
import omnitecCurrentOrganization from './omnitecReducers/omnitecCurrentOrganisation'
import omnitecLocks from './omnitecReducers/omnitecLocks'

import privateRooms from './omnitecReducers/omnitecPrivateRooms'
import commonArea from './omnitecReducers/omnitecCommonArea'

import omnitecEasymsCategories from './omnitecReducers/omnitecEasyms'
import omnitecEncoders from './omnitecReducers/omnitecEncoders'

export default combineReducers({
    auth,

    easymsOrganizations,

    bookingCategories,
    bookingCurrentOrganization,
    bookingOrganizations,
    bookingRates,
    bookingSync,
    bookingEasyms,

    h24Categories,
    h24CurrentOrganization,
    h24Organizations,
    h24Rates,
    h24Sync,
    h24Easyms,

    hwCategories,
    hwCurrentOrganization,
    hwOrganizations,
    hwRates,
    hwSync,
    hwEasyms,

    dobovoApartments,
    dobovoCurrentOrganization,
    dobovoOrganizations,
    dobovoSync,
    dobovoEasyms,

    expediaCategories,
    expediaCurrentOrganization,
    expediaOrganizations,
    expediaRates,
    expediaSync,
    expediaEasyms,

    omnitecOrganizations,
    omnitecCurrentOrganization,
    omnitecLocks,

    privateRooms,
    commonArea,

    omnitecEasymsCategories,
    omnitecEncoders,

    routing,
    toastr
})



// WEBPACK FOOTER //
// ./src/reducers/index.js